import { State } from "@store/types";
import { SegmentReportCommentsReduxProps } from "src/screens/Insights/Segments/SegmentReport/store/types";

export function getSegmentReportState(state: State) {
  return state.getIn(["insights_segment_reports"]) as SegmentReportCommentsReduxProps;
}
